import { adminWorkspaceDeveloperQueryKeys as e } from "./useAdminWorkspaceDeveloperQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminDevelopersApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useAdminDeveloperDirectoryQuery.ts
var r = 50, i = (i = {}, a = !0) => t({
	queryKey: e.directory(i),
	fetchPage: (e) => n.list({
		...i,
		page: e,
		pageSize: r
	}),
	key: "items",
	enabled: a
});
//#endregion
export { i as useAdminDeveloperDirectoryQuery };
